export enum LineOfBusinessEnum {
  GL = '241',
  AL = '242',
  WC = '243'
}
